import store from "../store";
import { storage } from "../index.js";

/**
 * Arquivo que irá exportar todos os beforeEach das rotas
 */
function isToken() {
  if (storage.getLocalToken() != null) {
    return true;
  } else {
    return false;
  }
}

export default async (to, from, next) => {
  document.title = to.name;
  /** O 'to.name' pega o Nome da Aba do Navegador */
  switch (to.name) {
    /** Pagina/Aba Home */

    case "login":
      /**
       *  Caso o token esteja setado redirecione para das
       * caso o usuario tente acessar o login
       */
      if (isToken()) {
        next({ name: "monitoramento" });
      } else {
        next();
      }

      break;

    case "monitoramento":
      if (to.name !== "login" && isToken() /*&& (await checkToken())*/) {
        try {
          await store.dispatch("auth/actionCheckToken");
          next();
        } catch (error) {
          storage.deleteLocalToken();
          next({ name: "login" });
        }
      } else {
        next({ name: "login" });
      }

      break;
  }
  next();
};
